import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CREATED, OK } from "../../constants/statusCode";
import { addRole } from "../../features/role-management/addRoleSlice";
import { getSingleRoleListing } from "../../features/role-management/getSingleRoleSlice";
import { getRoleModuleListing } from "../../features/role-management/moduleListSlice";
import { updateRole } from "../../features/role-management/updateRoleSlice";
import { roleConditionName } from "../../utils/utils";
import addRoleModuleValidation from "../../validations/roleModuleValidation/addRoleModuleValidation";
import Fields from "../form-components/Fields";
import Label from "../form-components/Label";
/* import { initialValues } from "./roleInitialValues"; */

const AddRole = ({ setSubCategory, roleEditId, setRoleEditID, setRoleName, roleName }) => {

  const [documentSelectAll, setDocumentSelectAll] = useState(false);
  const [modulePermission, setModulePermission] = useState([]);
  const [initialValues, setInitialValues] = useState({});
  const [selectAll, setSelectAll] = useState([
    { Documents: false },
    { "User Management": false },
    { Settings: false }
  ]);
  let documentCount = 0;
  let userManagementCount = 0;
  let settingCount = 0;
  let projectData = JSON.parse(localStorage.getItem("_user"));

  let dispatch = useDispatch();

  const { moduleListing = null, singleRoleData = null } = useSelector((state) => ({
    moduleListing: state.getRoleModuleListing.roleModuleListing,
    singleRoleData: state.getSingleRoleListingReducer.getSingleRoleListing,
  }));

  /**
   * submit function htmlFor add role
   */
  const roleHandleSubmit = async (values) => {
    if (roleEditId) {
      let newObj = {};
      newObj.role_name = values?.role_name;
      newObj.permission = values?.modulePermission;
      newObj.organization_uuid = projectData?.organizations[0].uuid;
      let { payload } = await dispatch(updateRole({ formData: newObj, id: roleEditId }));
      if (payload.status === OK) {
        setRoleEditID("");
        setRoleName("");
        setSelectAll([
          { Documents: false },
          { "User Management": false },
          { Settings: false }
        ]);
        dispatch(getSingleRoleListing(roleEditId));
        setSubCategory("roleManagement");
      }
    } else {
      let newObj = {};
      newObj.role_name = values?.role_name;
      newObj.permission = values?.modulePermission;
      newObj.organization_uuid = projectData?.organizations[0].uuid;
      let { payload } = await dispatch(addRole(newObj));
      if (payload.status === CREATED) {
        setSubCategory("roleManagement");
      }
    }
  }
  useEffect(() => {
    if (roleEditId) {
      dispatch(getSingleRoleListing(roleEditId));
    }
  }, [roleEditId]);

  useEffect(() => {
    dispatch(getRoleModuleListing());
  }, []);
  /* useEffect(() => {
      setInitialValues({
          document_select_all: false,
          user_select_all: false,
          settings_select_all: false,
          role_name: "",
          modulePermission:modulePermission})
  },[modulePermission]); */

  /**
   * useEffect for set edit and add data
   */
  useEffect(() => {
    setSelectAll([
      { Documents: false },
      { "User Management": false },
      { Settings: false }
    ]);
    if (roleEditId && moduleListing?.module?.length > 0) {
      /* dispatch(getSingleRoleListing(roleEditId)) */
      const updatedFour = moduleListing?.module?.length > 0 && moduleListing?.module?.map((data, index) => {
        const matchingCategory = singleRoleData?.Module?.find((c) => c.name === data.name);
        /* console.log("matchingCategory=",matchingCategory) */
        if (matchingCategory) {
          return {
            ...data,
            Modules: data.Modules.map((module, index) => {
              const matchingModule = matchingCategory.Modules.find(
                (m) => m.name === module.name
              );
              /* console.log(matchingModule,"matchingModule") */
              if (matchingCategory?.name === data?.name) {
                if (matchingModule?.name === module?.name) {
                  if (matchingModule?.Permissions?.length === module?.Permissions?.length) {
                    if (matchingCategory?.name === "User Management") {
                      userManagementCount += module?.Permissions?.length;
                      if (userManagementCount === 6) {
                        setSelectAll(prevState => {
                          return prevState.map(item => {
                            if (item.hasOwnProperty("User Management")) {
                              return { ...item, "User Management": true };
                            }
                            return item;
                          });
                        });
                      }
                    }
                    if (matchingCategory?.name === "Documents") {
                      documentCount += module?.Permissions?.length;
                      if (documentCount === 18) {
                        setSelectAll(prevState => {
                          return prevState.map(item => {
                            if (item.hasOwnProperty("Documents")) {
                              return { ...item, "Documents": true };
                            }
                            return item;
                          });
                        });
                      }
                    }
                    if (matchingCategory?.name === "Settings") {
                      settingCount += module?.Permissions?.length;
                      if (settingCount === 6) {
                        setSelectAll(prevState => {
                          return prevState.map(item => {
                            if (item.hasOwnProperty("Settings")) {
                              return { ...item, "Settings": true };
                            }
                            return item;
                          });
                        });
                      }
                    } /* else {
                                setSelectAllUser(false);
                                setSelectAllDocument(false);
                                setSelectAllSetting(false);
                            }  */
                  }
                }
              }
              if (matchingModule) {
                const permissions = module.Permissions.map((p1) => {
                  /* console.log("p1",p1) */
                  const matchingPermission = matchingModule.Permissions.find(
                    (p2) => p1.uuid === p2.uuid
                  );
                  /* console.log(matchingPermission,"888") */
                  if (matchingPermission) {
                    /* console.log(matchingPermission.is_checked,"888") */
                    return {
                      ...p1,
                      is_checked: matchingPermission.is_checked
                    };
                  }
                  return p1;
                });

                const missingPermissions = matchingModule.Permissions.filter(
                  (p2) => !module.Permissions.some((p1) => p1.uuid === p2.uuid)
                ).map((p2) => ({ ...p2, isChecked: false }));

                return {
                  ...module,
                  Permissions: [
                    ...permissions,
                    ...missingPermissions
                  ]
                };
              }
              return module;
            }),
          };
        } else {
          /* console.log("else") */
          // If matching category not found in two, then return category with empty Permissions array
          return {
            ...data,
            Modules: data.Modules.map((dataY, index) => ({
              ...dataY,
              Permissions: dataY.Permissions || [],
            })),
          };
        }
      });

      // Add any new categories from two that are not in one
      const updatedThree = moduleListing?.module.filter((dataT, index) => !singleRoleData?.Module?.some((data, index) => data.name === dataT.name));

      const finalArray = [...updatedFour, ...updatedThree];
      setModulePermission(finalArray)
      setInitialValues({
        document_select_all: false,
        user_select_all: false,
        settings_select_all: false,
        role_name: roleName,
      })
    } else {
      /*  dispatch(getRoleModuleListing()).then((data) => {
           setModulePermission(data?.payload?.data?.responseData?.module)
       }); */
      setModulePermission(moduleListing?.module)
      setInitialValues({
        document_select_all: false,
        user_select_all: false,
        settings_select_all: false,
        role_name: "",
      })
      /* setInitialValues({
          document_select_all: false,
          user_select_all: false,
          settings_select_all: false,
          role_name: "",
          modulePermission:modulePermission}) */
    }
  }, [moduleListing, singleRoleData, roleEditId, roleName])

  return (
    <>
      {moduleListing?.module?.length > 0 && <Formik
        /* initialValues={{...initialValues, moduleData:modulePermission}} */

        initialValues={{ ...initialValues, modulePermission }}
        validationSchema={addRoleModuleValidation}
        onSubmit={roleHandleSubmit}
        enableReinitialize={true}
      >
        {({
          values,
          handleChange,
          handleBlur,
          touched,
          errors,
          isSubmitting,
          handleSubmit,
          setFieldValue,
        }) => {

          /**
           * handle change for all module checkbox
           * @param {*} moduleName 
           * @param {*} permissionIndex 
           * @param {*} category 
           */
          const handleChangeCheckbox = (moduleName, permissionIndex, category, permissionName) => {
            let updateArray = values?.modulePermission?.map((newData, indexOne) => {
              if (newData.name === category) {
                return {
                  name: newData.name,
                  uuid: newData.uuid,
                  Modules: newData?.Modules?.map((data, indexTwo) => {

                    if (data.name === moduleName) {
                      return {
                        ...data,
                        Permissions: data.Permissions.map((permissionData, index) => {
                          if (roleConditionName.includes(permissionData.name) && (data.name === "Profile" || data.name === "Manage Projects")) {
                            return { ...permissionData, is_checked: permissionName === "View" ? !permissionData.is_checked : true }
                          }
                          if (index === permissionIndex) {
                            return { ...permissionData, is_checked: !permissionData.is_checked }
                          }

                          return permissionData;
                        })
                      }
                    } else if (moduleName === "document_select_all") {
                      return {
                        ...data,
                        Permissions: data.Permissions.map((permissionData, index) => {
                          if (newData?.name === "User Management") {
                            // setSelectAll({...selectAll, "User Management": !selectAll["User Management"]})
                            setSelectAll(prevState => {
                              return prevState.map(item => {
                                if (item.hasOwnProperty("User Management")) {
                                  return { ...item, "User Management": permissionIndex.target.checked };
                                }
                                return item;
                              });
                            });
                          }
                          if (newData?.name === "Documents") {
                            setSelectAll(prevState => {
                              return prevState.map(item => {
                                if (item.hasOwnProperty("Documents")) {
                                  return { ...item, "Documents": permissionIndex.target.checked };
                                }
                                return item;
                              });
                            });
                          }
                          if (newData?.name === "Settings") {
                            setSelectAll(prevState => {
                              return prevState.map(item => {
                                if (item.hasOwnProperty("Settings")) {
                                  return { ...item, "Settings": permissionIndex.target.checked };
                                }
                                return item;
                              });
                            });
                          }
                          return { ...permissionData, is_checked: permissionIndex.target.checked /* !permissionData.is_checked */ }
                        })
                      }
                    }
                    return data;
                  })
                }

              }
              return newData;
            })

            setFieldValue("modulePermission", updateArray)
          }
          return (<Form>
            <div className='content-right-box content-right-box-role'>
              <div className='intro-table-search container-fluid'>
                <div className='row align-items-center py-3'>
                  <div className='col-12 col-md-6 col-xl-6'>
                    <h5 className='intro-title'>
                      {roleEditId ? 'Edit Role' : 'Add Role'}
                    </h5>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xxl-6 col-xl-6 col-lg-12'>
                    <div className='form-group'>
                      <Label className="form-label" htmlFor="role_name">
                        Enter Role Name*
                      </Label>
                      <Fields
                        type="text"
                        placeholder="Enter Role Name"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="role_name"
                        value={values.role_name}
                        className="form-control"
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <h2 className='sub-title'>Permissions</h2>
                {values?.modulePermission?.map((data, index) => {
                  return (<div className='permissions-block' key={index}>
                    <div className='permissions-head'>
                      <div className='row align-items-center'>
                        <div className='col-lg-6'>
                          <h3>{data.name}</h3>
                        </div>
                        <div className='col-lg-6  align-content-end d-flex'>
                          <div className='form-check ms-auto my-0'>
                            <Label className="form-check-label" htmlFor="document_select_all">
                              Select All
                            </Label>
                            <Fields
                              type="checkbox"
                              touched={touched}
                              className="form-check-input"
                              name="document_select_all"
                              onChange={(e) => {
                                setFieldValue("document_select_all", e.target.checked);
                                setDocumentSelectAll(!documentSelectAll);
                                handleChangeCheckbox("document_select_all", e, data.name)
                              }}
                              checked={selectAll[index] && selectAll[index][data?.name]}
                            // checked={values?.document_select_all}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <ul className='permissions-row'>

                      {data?.Modules?.map((moduleData, index) => {
                        return (
                          <li className="permissions-row" key={index}>
                            <div className="row align-items-center">
                              <div className="col-xxl-2 col-xl-2 col-lg-12 mb-sm-2 mb-xl-0">
                                <h4>{moduleData.name}</h4>
                              </div>
                              <div className="col-xxl-10 col-xl-10 col-lg-12">
                                <ul className="permissions-check-row d-flex flex-wrap">
                                  {moduleData.Permissions.map(
                                    (p, indexThree) => {
                                      return (
                                        <li
                                          className="permissions-check-cell"
                                          key={indexThree}
                                        >
                                          <div className="form-check ms-auto my-0">
                                            <Label
                                              className="form-check-label"
                                              htmlFor="document_select_all"
                                            >
                                              {p.name}
                                            </Label>
                                            <Fields
                                              type="checkbox"
                                              className="form-check-input"
                                              id={indexThree}
                                              onChange={(e) => {
                                                handleChangeCheckbox(
                                                  moduleData.name,
                                                  indexThree,
                                                  data.name,
                                                  p.name
                                                );
                                              }}
                                              name={p?.name}
                                              checked={
                                                (moduleData.name ===
                                                  "Create Documents" ||
                                                  moduleData.name ===
                                                    "Upload Documents") &&
                                                p.name === "View"
                                                  ? true
                                                  : p?.is_checked
                                              }
                                              value={
                                                (moduleData.name ===
                                                  "Create Documents" ||
                                                  moduleData.name ===
                                                    "Upload Documents") &&
                                                p.name === "View"
                                                  ? true
                                                  : p?.is_checked
                                              }
                                              disabled={
                                                (moduleData.name ===
                                                  "Create Documents" ||
                                                  moduleData.name ===
                                                    "Upload Documents") &&
                                                p.name === "View"
                                                  ? true
                                                  : false
                                              }
                                            />
                                            {/* <input className='form-check-input' type='checkbox' id='cd-1' />
                                                                                <label className='form-check-label' htmlFor='cd-1'>
                                                                                    View
                                                                                </label> */}
                                          </div>
                                        </li>
                                      );
                                    }
                                  )}
                                  {/* <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-2' checked />
                                                                <label className='form-check-label' htmlFor='cd-2'>
                                                                    Write
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-3' />
                                                                <label className='form-check-label' htmlFor='cd-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-4' checked />
                                                                <label className='form-check-label' htmlFor='cd-4'>
                                                                    Sync
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-5' />
                                                                <label className='form-check-label' htmlFor='cd-5'>
                                                                    Unsync
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-6' checked />
                                                                <label className='form-check-label' htmlFor='cd-6'>
                                                                    Archive
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='cd-7' />
                                                                <label className='form-check-label' htmlFor='cd-7'>
                                                                    Unarchive
                                                                </label>
                                                            </div>
                                                        </li> */}
                                </ul>
                              </div>
                            </div>
                          </li>
                        );
                      })}

                      {/* <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Upload Documents</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-1' />
                                                                <label className='form-check-label' htmlFor='ud-1'>
                                                                    View
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-2' checked />
                                                                <label className='form-check-label' htmlFor='ud-2'>
                                                                    Upload
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-3' />
                                                                <label className='form-check-label' htmlFor='ud-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-4' checked />
                                                                <label className='form-check-label' htmlFor='ud-4'>
                                                                    Sync
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-5' />
                                                                <label className='form-check-label' htmlFor='ud-5'>
                                                                    Unsync
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-6' checked />
                                                                <label className='form-check-label' htmlFor='ud-6'>
                                                                    Archive
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-7' />
                                                                <label className='form-check-label' htmlFor='ud-7'>
                                                                    Unarchive
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='ud-8' />
                                                                <label className='form-check-label' htmlFor='ud-8'>
                                                                    Download
                                                                </label>
                                                            </div>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </li> */}
                      {/* <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Labels</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='lb-1' />
                                                                <label className='form-check-label' htmlFor='lb-1'>
                                                                    Add
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='lb-2' checked />
                                                                <label className='form-check-label' htmlFor='lb-2'>
                                                                    Update
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='lb-3' />
                                                                <label className='form-check-label' htmlFor='lb-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li> */}
                    </ul>
                  </div>)
                })}
                {/*  <div className='permissions-block'>
                                    <div className='permissions-head'>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6'>
                                                <h3>User Management </h3>
                                            </div>
                                            <div className='col-lg-6  align-content-end d-flex'>
                                                <div className='form-check ms-auto my-0'>
                                                    <Label className="form-check-label" htmlFor="user_select_all">
                                                        Select All
                                                    </Label>
                                                    <Fields
                                                        type="checkbox"
                                                        touched={touched}
                                                        className="form-check-input"
                                                        name="user_select_all"
                                                        onChange={handleChange}
                                                        checked={values?.user_select_all}
                                                    />
                                                    
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <ul className='permissions-row'>
                                        <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Users</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umu-1' />
                                                                <label className='form-check-label' htmlFor='umu-1'>
                                                                    Add
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umu-2' checked />
                                                                <label className='form-check-label' htmlFor='umu-2'>
                                                                    Update
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umu-3' />
                                                                <label className='form-check-label' htmlFor='umu-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                        <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Roles</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umr-1' />
                                                                <label className='form-check-label' htmlFor='umr-1'>
                                                                    Add
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umr-2' checked />
                                                                <label className='form-check-label' htmlFor='umr-2'>
                                                                    Upload
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='umr-3' checked />
                                                                <label className='form-check-label' htmlFor='umr-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div> */}
                {/*  <div className='permissions-block'>
                                    <div className='permissions-head'>
                                        <div className='row align-items-center'>
                                            <div className='col-lg-6'>
                                                <h3>Settings</h3>
                                            </div>
                                            <div className='col-lg-6  align-content-end d-flex'>
                                                <div className='form-check ms-auto my-0'>
                                                    <Label className="form-check-label" htmlFor="settings_select_all">
                                                        Select All
                                                    </Label>
                                                    <Fields
                                                        type="checkbox"
                                                        touched={touched}
                                                        className="form-check-input"
                                                        name="settings_select_all"
                                                        onChange={handleChange}
                                                        checked={values?.settings_select_all}
                                                    />
                                                   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className='permissions-row'>
                                        <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Profile</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='pst-1' />
                                                                <label className='form-check-label' htmlFor='pst-1'>
                                                                    View
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='pst-2' checked />
                                                                <label className='form-check-label' htmlFor='pst-2'>
                                                                    Update
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                        <li className='permissions-row'>
                                            <div className='row align-items-center'>
                                                <div className='col-xxl-2 col-xl-2 col-lg-4'>
                                                    <h4>Manage Pojects</h4>
                                                </div>
                                                <div className='col-xxl-10 col-xl-10 col-lg-8'>
                                                    <ul className='permissions-check-row d-flex flex-wrap'>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='smp-1' />
                                                                <label className='form-check-label' htmlFor='smp-1'>
                                                                    Add
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='smp-2' checked />
                                                                <label className='form-check-label' htmlFor='smp-2'>
                                                                    Upload
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='smp-3' checked />
                                                                <label className='form-check-label' htmlFor='smp-3'>
                                                                    Delete
                                                                </label>
                                                            </div>
                                                        </li>
                                                        <li className='permissions-check-cell'>
                                                            <div className='form-check ms-auto my-0'>
                                                                <input className='form-check-input' type='checkbox' id='smp-4' />
                                                                <label className='form-check-label' htmlFor='smp-4'>
                                                                    View
                                                                </label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div> */}
                <div className='row'>
                  <div className='col-lg-12 text-end'>
                    <button type="submit" className='btn btn-primary-md' onClick={handleSubmit}>Save</button>
                  </div>
                </div>
              </div>
            </div>
          </Form>)
        }}
      </Formik>}
    </>
  );
};

export default AddRole;